"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
query subscriptions($id: Int!) {
  coachTrainee(id: $id) {
    periods {
      periodId: id
      subscriptionId: periodId 
      start
      end
      duration
      model
      coachingDays
      plan {
        name  
      }
      trainingLocation {
        placeName
        details
      }
      coach {
        name
      }
    }
    currentPeriod {
      subscriptionId: periodId
    }
  }
}
`;
//# sourceMappingURL=subscriptionsQuery.js.map